// extracted by mini-css-extract-plugin
export default {"scroll-container":"NewsScroll_scroll-container__dhcl0","scroll":"NewsScroll_scroll__s+QjR"};